import React, { useContext } from 'react'
// Icons
import { ReactComponent as SuccessIcon } from './icons/success.svg'
import { ReactComponent as ErrorIcon } from './icons/error.svg'
import CortLogoImage from '../../icons/cort-logo.png'
import Button from '../../../../../Forms/Button'
import Modal from '../../../../../Modal'
import { captureEvent } from '../../../../../../analytics'
import { analyticsEvents } from '../../../../../../analytics/events'
import { AppConfigContext } from '../../../../../../context/AppConfig'
import VendorLogo from '../../../../../VendorLogo'
import PropertyLogo from '../../../../../PropertyLogo'

export const EResult = {
  SUCCESS: 'success',
  ERROR: 'error',
}

function Result({ result, onClose, modal = true }) {
  const { isSWApp, isPDApp, isAvalonApp } = useContext(AppConfigContext)

  function getSuccessTitle() {
    if (isPDApp) {
      return 'Your details have been successfully sent to the property'
    }
    if (isSWApp) {
      return 'Your details have been successfully sent to the vendor'
    }
    if (isAvalonApp) {
      return (
        <span>
          Your details have been successfully <br className="portrait:!hidden lg:!hidden"></br> sent
        </span>
      )
    } else {
      return (
        <span>
          Your details have been successfully <br className="portrait:!hidden lg:!hidden"></br> sent to CORT
        </span>
      )
    }
  }

  function getSuccessMessage() {
    if (isAvalonApp) {
      return null
    }
    if (isSWApp || isPDApp) {
      return 'A representative will contact you soon to help you furnish your new place.'
    } else {
      return (
        <span>
          A representative will contact you<br className="hidden portrait:inline-block lg:!hidden"></br> within 24
          business<br className="portrait:hidden lg:!hidden"></br> hours to help you
          <br className="hidden portrait:inline-block lg:!hidden"></br> furnish your new place.
        </span>
      )
    }
  }

  const content = (
    <>
      <div className="flex flex-col items-center mt-[80px] portrait:mt-[0] lg:mt-[0]">
        <div className="flex justify-center items-center">
          {result === EResult.SUCCESS ? <SuccessIcon /> : <ErrorIcon />}
        </div>
        <div className="font-semibold text-center text-[21px]  leading-[29px] lg:text-[22px] lg:leading-[29px] mt-[16px] portrait:mt-[32px] lg:mt-[32px]">
          {result === EResult.SUCCESS ? getSuccessTitle() : 'Something went wrong...'}
        </div>
        <div className={`text-[18px] lg:leading-[24px] text-center mt-[4px] mb-[32px] text-[#3D4256] ${isPDApp ? '!mt-[16px]' : ''}`}>
          {result === EResult.SUCCESS
            ? getSuccessMessage()
            : 'We encountered an issue while processing your request. Please try again later. '}
        </div>
        <div>
          <Button
            onClick={() => {
              if (result === EResult.SUCCESS) {
                captureEvent(analyticsEvents.SUBMIT_SUCCEEDED_OK_TAPPED)
              }
              if (result === EResult.ERROR) {
                captureEvent(analyticsEvents.SUBMIT_FAILED_OK_TAPPED)
              }
              onClose()
            }}
            className={`w-[172px] lg:w-[280px] ${result === EResult.SUCCESS ? '!bg-[#16C270]' : '!bg-[#EA002C]'}`}
          >
            OK
          </Button>
        </div>
      </div>
    </>
  )

  return modal ? (
    <Modal className={`${isPDApp ? 'lg:w-[440px]' : 'lg:w-[420px]'} lg:py-[70px]`}>{content}</Modal>
  ) : (
    <div className="fixed portrait:absolute lg:absolute top-0 left-0 h-full w-full bg-[white] flex justify-center items-center px-[24px] z-[20]">
      <div className="absolute top-0 w-full flex justify-center">
        {!isSWApp && !isAvalonApp && (
          <>
            {isPDApp ? (
              <>
                <div className='flex items-center'>
                  <img src={CortLogoImage} alt="" className="h-[72px]" />
                  <div className='ml-[16px]'><PropertyLogo /></div>
                </div>
              </>
            ) : (
              <img src={CortLogoImage} alt="" className="h-[72px]" />
            )}
          </>
        )}
        {isSWApp && (
          <div className="mt-[32px]">
            <VendorLogo className="!h-[27px]" />
          </div>
        )}
      </div>
      {content}
    </div>
  )
}

export default Result
